import { mapState } from 'vuex';
import cloneDeep from 'lodash/cloneDeep';
import NiotaClassicApiService from '@/services/niotaClassicApiService';
import formMixin from '../formMixin';
import { codemirror } from 'vue-codemirror';
import 'codemirror/lib/codemirror.css';
import 'codemirror/theme/base16-dark.css';
import 'codemirror/theme/duotone-light.css';
import 'codemirror/mode/javascript/javascript.js';
export default {
  name: 'NiotaClassicConsumersJsonTrafo',
  components: {
    codemirror
  },
  mixins: [formMixin],
  props: {
    jsontr: {
      type: Object,
      required: true
    }
  },
  data: function () {
    return {
      lclObject: {},
      lcltt: '',
      testJSON: '{"source_time":"2020-11-17T07:15:39.935Z","source_id":"321","source_data":{"updated_at":"2020-11-17T07:15:39.935627","uid":"b5d2ff85-b68f-4a5a-905f-4c67a6b5a57e","spreading_factor":7,"server_data":{"size":21,"raw":"QF78sGaAxasFdBbcZk8uC+nceSbA","mtype":"unconfirmed_data_up","modu":"LORA","mic_pass":true,"mac_cmds":[],"gwrx":[{"tmst":170035227,"time":"2020-11-17T07:15:38.462104Z","srv_rcv_time":1605597338597592,"rssi":-88,"lsnr":7.2,"gweui":"00000008004A084F"},{"tmst":153390259,"time":"2020-11-17T07:15:38.776079Z","srv_rcv_time":1605597338771234,"rssi":-118,"lsnr":-8.5,"gweui":"0000024B080606AA"}],"freq":868.5,"fopts":"","dev_addr_hex":"66b0fc5e","datr":"SF7BW125","codr":"4/5","chan":2},"raw_payload":"405EFCB06680C5AB057416DC664F2E0BE9DC7926C0","port":5,"payload_encrypted":false,"payload":"0100BA023A070D82","parsed_source":{"VDDID":112,"VDD":3.458,"TempID":16,"Temp":18.6,"HumidityID":2,"Humidity":58},"parsed_packet":{"port":5,"pending":false,"mtype":"unconfirmed_data_up","mic_pass":true,"major":0,"mac_cmds":[],"fopts_len":0,"fcnt":43973,"dir":"up","dev_addr_hex":"66b0fc5e","adrackreq":false,"adr":true,"ack":false},"parsed":{"VDDID":112,"VDD":3.458,"TempID":16,"Temp":18.6,"HumidityID":2,"Humidity":58},"organization_id":6745,"organization":{},"mic_pass":true,"location":null,"inserted_at":"2020-11-17T07:15:39.935641","frame_counter":43973,"device_id":6169,"device_class":{"visibility":"everyone","updated_at":"2017-12-14T13:54:44.305977","script":{"variables":{"VDDID":{"type":"hidden","order":4,"name":"VDDID"},"VDD":{"type":"number","suffix":"V","order":5,"name":"VDD","digits":2},"TempID":{"type":"hidden","order":0,"name":"TempID"},"Temp":{"type":"number","suffix":"°C","order":1,"name":"Temp"},"HumidityID":{"type":"hidden","order":2,"name":"HumidityID"},"Humidity":{"type":"number","suffix":"%","order":3,"name":"Humidity"}},"parseElements":[{"type":"int","target":"TempID","bits":"12"},{"type":"int","target":"Temp","signed":true,"signComplement":"2","bits":"12"},{"type":"int","target":"HumidityID","bits":"8"},{"type":"int","target":"Humidity","bits":"8"},{"type":"int","target":"VDDID","bits":"12"},{"type":"int","target":"VDD","bits":"12"}],"calculateElements":[{"target":"Temp","formula":"Temp/10"},{"target":"VDD","formula":"VDD/1000"}]},"organization_id":-1,"organization":{},"name":"Elsys Temp + Feuchtigkeitssensor","inserted_at":"2017-12-14T13:51:50.592445","id":138,"devices":{},"description":null},"device":{"organization_id":6745,"name":"BFD Raum H3.006 (T+H)","id":6169,"eui":"A81758FFFE0354A0","device_class_id":138,"address":"66B0FC5E"},"bandwidth":125,"ack":null},"source":"firefly","signal":{"snr":7.2,"rssi":-88,"gateway":"00000008004A084F"},"payload":"0100BA023A070D82","parser_name":null,"parsed_tags":null,"parsed":{"VDD":3.458,"Temp":18.6,"Humidity":58},"lora":{"spreading_factor":7,"fport":5},"eui":"A81758FFFE0354A0","device_type_id":3,"device_name":"BFD Raum H3.006 (T+H)","device_id":694,"application_id":237,"account_id":236,"uid":0}',
      exampleTrafo: {
        a: '{{source_id}}',
        b: {
          d: ['{{source_data.server_data.gwrx}}', {
            f: '{{rssi}}',
            g: '{{gweui}}'
          }]
        }
      },
      trafoTestResult: '',
      tabItem: 1,
      jsonCheck: null,
      jsonCheckText: null,
      jsonMessage: 'Switch mode to edit json transformation routine',
      cmOptions: {
        readOnly: true,
        tabSize: 4,
        mode: {
          name: 'javascript',
          json: true
        },
        firstLineNumber: 0,
        theme: this.$store.state.app.UiTheme ? 'base16-dark' : 'duotone-light',
        lineNumbers: true,
        line: true,
        foldGutter: true,
        styleActiveLine: true,
        styleSelectedText: true,
        hintOptions: {
          completeSingle: false
        },
        lineWrapping: false
      }
    };
  },
  computed: {
    ...mapState('app', ['inpOutlined', 'inpFilled', 'image', 'color', 'UiTheme', 'permissions']),
    cloading() {
      return this.$store.state.app.loading;
    },
    noTesting() {
      let result = true;
      if (this.cmOptions.readOnly && this.jsonCheck !== 'check-nok' && this.lclObject.transform_template && this.lclObject.transform_template !== null || this.cloading) {
        result = false;
      }
      return result;
    }
  },
  watch: {
    jsontr() {
      this.parseJSON();
    }
  },
  mounted() {
    this.parseJSON();
  },
  methods: {
    switchMode() {
      if (!this.cmOptions.readOnly && this.lcltt !== '') {
        try {
          this.lclObject.transform_template = JSON.parse(this.lcltt);
          this.jsonCheck = 'check-ok';
          this.jsonCheckText = 'check-ok-text';
          this.jsonMessage = 'Syntax check ok, data can be saved';
          this.$emit('jsonTrafoChanged', this.lclObject.transform_template);
        } catch (e) {
          // Anweisungen für jeden Fehler
          this.jsonCheck = 'check-nok';
          this.jsonCheckText = 'check-nok-text';
          this.jsonMessage = `Syntax error in json transformation: ${e}`;
          return;
        }
      } else if (!this.cmOptions.readOnly && this.lcltt === '') {
        this.jsonCheck = '';
        this.jsonCheckText = '';
        this.jsonMessage = '';
        this.lclObject.transform_template = null;
        this.trafoTestResult = '';
        this.$emit('jsonTrafoChanged', this.lclObject.transform_template);
      }
      this.cmOptions.readOnly = !this.cmOptions.readOnly;
    },
    parseJSON() {
      this.lclObject = cloneDeep(this.jsontr);
      try {
        this.lcltt = JSON.stringify(this.lclObject.transform_template, null, 2);
        if (!this.lcltt) {
          this.lcltt = '';
        }
      } catch (e) {
        this.lcltt = '';
      }
    },
    testTrafo() {
      let data = {
        data: this.testJSON,
        template: this.lclObject.transform_template,
        timeout: {}
      };
      NiotaClassicApiService.consumersTestJSONTrafo(data).then(res => {
        this.$snack('Tranformation works fine!', 'success');
        try {
          this.trafoTestResult = JSON.stringify(res.data.result.body.res, null, 2);
        } catch (e) {
          this.trafoTestResult = 'An error occured while transforming the result to a string.';
        }
      }).catch(() => {
        this.$snack('Error while transforming JSON!', 'error');
      });
    },
    pasteDefault() {
      this.lcltt = JSON.stringify(this.exampleTrafo, null, 2);
    }
  }
};